module.exports = __webpack_public_path__ + "media/images/freejob_banner_sp-c6490639588d0e2fae4d11fabdb157ec.png";